import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UserService} from "../../../../../../@shared/services/user.service";

@Component({
  selector: 'app-reset-referral-income',
  templateUrl: './reset-referral-income.component.html',
  styleUrls: ['./reset-referral-income.component.scss']
})
export class ResetReferralIncomeComponent implements OnInit {

  public resetRefIncomeForm = this.fb.group({
    comment: ['', [Validators.required]],
    dateFrom: [null, [Validators.required]],
    dateTo: [null, [Validators.required]]
  })

  constructor(private dialogRef: MatDialogRef<ResetReferralIncomeComponent>,
              private fb: FormBuilder,
              private userService: UserService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.resetRefIncomeForm.patchValue({dateFrom: this.data.date.start, dateTo: this.data.date.end});
  }

  public resetReferralIncome(): void {
    if (this.data.element) {
      this.userService.resetAllIncomeFromTarget(this.data.element.id, this.resetRefIncomeForm.value).subscribe(() => this.dialogRef.close(true));
    } else {
      this.userService.resetAllIncome(this.resetRefIncomeForm.value).subscribe(() => this.dialogRef.close(true));
    }
  }

  public close(): void {
    this.dialogRef.close(false);
  }

}
